import { Base } from "ui/Scripts/source/framework/base";
import { IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export const AppReportStateIdFilterActive = "00000000-0000-0000-0000-000000000001";
export const AppReportStateIdFilterdDraft = "00000000-0000-0000-0000-000000000002";
export const AppReportStateIdFilterdPublished = "00000000-0000-0000-0000-000000000003";
export const AppReportStateIdFilterArchived = "00000000-0000-0000-0000-000000000004";

export interface IAppReportPageFilterLists {
    units: IIdTitleNode[];
    states: IIdTitle[];
    // priorities: IIdTitle[];
    // taskTypes: ITaskEditTypeItem[];
    // handlers: IIdTitle[];
    // personsInCharge: IIdTitle[];
}

export interface IAppReportPageFilterState {
    selectedUnitIds: string[];
    selectedStateIds: string[];
    // selectedPriorityIds: string[];
    // selectedTaskTypeIds: string[];
    // selectedHandlerUserCodes: string[];
    // selectedPersonInChargeUserCodes: string[];
    // selectedTaskTypeHeaderFields: string;
    // selectedTaskTypeFields: string;
}

export interface IAppReportPageGeneralFilter {
    unitIds: string[];
    stateIds: string[];
    // priorityIds: string[];
    // taskTypeIds: string[];
    // handlerUserCodes: string[];
    // personInChargeUserCodes: string[];
    // taskTypeHeaderFields: string;
    // taskTypeFields: string;
}

export interface IAppReportPageGeneralFilterChange extends IAppReportPageGeneralFilter {
    notChanged: boolean;
}

export const getAppReportPageGeneralFilterFromFilterState = (state: IAppReportPageFilterState): IAppReportPageGeneralFilter => {
    return {
        unitIds: state.selectedUnitIds ? state.selectedUnitIds.filter(i => i !== Base.emptyGuid) : [],
        stateIds: state.selectedStateIds ? state.selectedStateIds.filter(i => i !== Base.emptyGuid) : [],
        // priorityIds: state.selectedPriorityIds ? state.selectedPriorityIds.filter(i => i !== Base.emptyGuid) : [],
        // taskTypeIds: state.selectedTaskTypeIds ? state.selectedTaskTypeIds.filter(i => i !== Base.emptyGuid) : [],
        // handlerUserCodes: state.selectedHandlerUserCodes ? state.selectedHandlerUserCodes.filter(i => !!i) : [],
        // personInChargeUserCodes: state.selectedPersonInChargeUserCodes ? state.selectedPersonInChargeUserCodes.filter(i => !!i) : [],
        // taskTypeHeaderFields: state.selectedTaskTypeHeaderFields ? state.selectedTaskTypeHeaderFields : null,
        // taskTypeFields: state.selectedTaskTypeFields ? state.selectedTaskTypeFields : null
    };
};

export const getFilterStateFromAppReportPageGeneralFilter = (generalFilter: any): IAppReportPageFilterState => {
    return {
        selectedUnitIds: generalFilter && generalFilter.unitIds && generalFilter.unitIds.length > 0 ? generalFilter.unitIds : [Base.emptyGuid],
        selectedStateIds: generalFilter && generalFilter.stateIds && generalFilter.stateIds.length > 0 ? generalFilter.stateIds : [Base.emptyGuid],
        // selectedPriorityIds: generalFilter && generalFilter.priorityIds && generalFilter.priorityIds.length > 0 ? generalFilter.priorityIds : [Base.emptyGuid],
        // selectedTaskTypeIds: generalFilter && generalFilter.taskTypeIds && generalFilter.taskTypeIds.length > 0 ? generalFilter.taskTypeIds : [Base.emptyGuid],
        // selectedHandlerUserCodes: generalFilter && generalFilter.handlerUserCodes && generalFilter.handlerUserCodes.length > 0 ? generalFilter.handlerUserCodes : [""],
        // selectedPersonInChargeUserCodes: generalFilter && generalFilter.personInChargeUserCodes && generalFilter.personInChargeUserCodes.length > 0 ? generalFilter.personInChargeUserCodes : [""],
        // selectedTaskTypeHeaderFields: generalFilter && generalFilter.taskTypeHeaderFields ? generalFilter.taskTypeHeaderFields : "",
        // selectedTaskTypeFields: generalFilter && generalFilter.taskTypeFields ? generalFilter.taskTypeFields : "",
    };
};

export const getAppReportPageGeneralFilterNotChanged = (prevFilter: IAppReportPageGeneralFilter, filter: IAppReportPageGeneralFilter): boolean => {
    return Base.equalStrArrays(prevFilter.unitIds, filter.unitIds) &&
        Base.equalStrArrays(prevFilter.stateIds, filter.stateIds)
    // Base.equalStrArrays(prevFilter.stateIds, filter.stateIds) &&
    // Base.equalStrArrays(prevFilter.priorityIds, filter.priorityIds) &&
    // Base.equalStrArrays(prevFilter.taskTypeIds, filter.taskTypeIds) &&
    // Base.equalStrArrays(prevFilter.handlerUserCodes, filter.handlerUserCodes) &&
    // Base.equalStrArrays(prevFilter.personInChargeUserCodes, filter.personInChargeUserCodes) &&
    // (prevFilter.taskTypeHeaderFields ?? "") === (filter.taskTypeHeaderFields ?? "") &&
    // (prevFilter.taskTypeFields ?? "") === (filter.taskTypeFields ?? "")
    ;
};

export const getAppReportPageGeneralFilterChange = (prevProps: IAppReportPageFilterState, props: IAppReportPageFilterState): IAppReportPageGeneralFilterChange => {
    const prevFilter = getAppReportPageGeneralFilterFromFilterState(prevProps);
    const filter = getAppReportPageGeneralFilterFromFilterState(props);
    return {
        ...filter,
        notChanged: getAppReportPageGeneralFilterNotChanged(prevFilter, filter)
    };
};